import { render, staticRenderFns } from "./ReviewBlockArea.vue?vue&type=template&id=9dc36406&scoped=true"
import script from "./ReviewBlockArea.vue?vue&type=script&lang=js"
export * from "./ReviewBlockArea.vue?vue&type=script&lang=js"
import style0 from "./ReviewBlockArea.vue?vue&type=style&index=0&id=9dc36406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc36406",
  null
  
)

export default component.exports